import {useQuery} from "react-query";
import api from "../api";

export const useGetMarketStages = () => {
    return useQuery(["market-stages"], () => {
        return api.get("market-stage").then((res) => res.data);
    });
}